import { Table } from 'antd';

import { OrganizationAnalyticsFilters } from '../components';
import {
  useOrganizationAnalytics,
  useOrganizationAnalyticsEffects,
} from '../hooks';

import '@pages/Organizations/OrganizationAnalytics/styles/OrganizationAnalytics.desktop.scss';

export const OrganizationAnalytics = () => {
  const {
    search,
    setSearch,
    period,
    setPeriod,
    tableData,
    mainColumns,
    childColumns,
    total,
    isLoading,
    pagination,
    fetchOrganizationsAnalytics,
    handleReset,
    handleSearch,
    handlePaginationChange,
  } = useOrganizationAnalytics();

  useOrganizationAnalyticsEffects({ fetchOrganizationsAnalytics });

  return (
    <div className="organizations-page">
      <OrganizationAnalyticsFilters
        search={search}
        setSearch={setSearch}
        period={period}
        setPeriod={setPeriod}
        handleReset={handleReset}
        handleSearch={handleSearch}
      />

      <Table
        columns={mainColumns}
        dataSource={tableData}
        rowKey="id"
        loading={isLoading}
        tableLayout="fixed"
        pagination={{
          current: pagination.page,
          pageSize: pagination.pageSize,
          total,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
          onChange: (page, pageSize) => {
            handlePaginationChange(page, pageSize);
          },
        }}
        expandable={{
          expandedRowRender: (record) => (
            <Table
              columns={childColumns}
              dataSource={record._children || []}
              pagination={false}
              rowKey="id"
              showHeader={false}
              size="small"
              tableLayout="fixed"
            />
          ),
        }}
      />
    </div>
  );
};
